<script setup lang="ts">
import { RouterLink } from 'vue-router'
import Card from '@/components/ui/Card.vue'
import Icon from '@/components/icons/Icon.vue'
import type { IconName } from '@/components/icons/Icon.vue'

defineProps<{
  id: string
  label: string
  icon: IconName
}>()
</script>

<template>
  <RouterLink :to="`/calculators?category=${id}`" class="category-card">
    <Card padding="md" raised accent="accent" hover>
      <span class="category-card__icon">
        <Icon :name="icon" :size="32" />
      </span>
      <span class="category-card__label">{{ label }}</span>
    </Card>
  </RouterLink>
</template>

<style scoped>
.category-card {
  text-decoration: none;
  color: inherit;
  display: block;
}

.category-card__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: var(--radius-md);
  background: linear-gradient(135deg, rgb(217 119 6 / 0.12), rgb(251 191 36 / 0.08));
  color: var(--color-accent-dark);
  margin-bottom: var(--space-3);
}

.category-card__label {
  font-weight: var(--font-semibold);
  color: var(--color-text);
}
</style>
